"use client"

import { useEffect } from 'react'
import { useRouter } from 'next/navigation'
import { useStore } from '@/lib/store'

/**
 * 1.67 — while this device is locked to the kitchen screen, every main-app route bounces to /kitchen (the kiosk
 * guard's pattern). Turned off only by the system PIN on the kitchen screen's exit; cleared on sign-out.
 */
export function KitchenGuard() {
  const kitchenMode = useStore((s) => s.kitchenMode)
  const router = useRouter()

  useEffect(() => {
    if (kitchenMode) router.replace('/kitchen')
  }, [kitchenMode, router])

  return null
}
